import React from 'react';

import { GetAdCampaignsType } from 'application/repositories/media/types';
import { DEFAULT_AD_CAMPAIGN_STATUSES } from 'application/pages/AdsPage/renderer/AdsToolBar/consts';

import {
  PaginationInfoType,
  AdCampaignQueryFilter,
  AdCampaignPureType,
  AdCampaignStatusesEnum,
  AdCampaignQueryPagination,
  AdCampaignsQueryPaginationType,
  AdCampaignTypeEnum,
  ReplicationRole,
  AdCampaignMediaTypeEnum,
} from 'domain/api/graphql/generated';

/** useAdCampaignsPaginationPresenter Types */
export type DefaultAdCampaignFiltersType = {
  companyIds: string[];
  query?: string;
  statuses: AdCampaignStatusesEnum[];
  companyTagIds?: string[];
  type?: AdCampaignTypeEnum[];
  replicationRoles: ReplicationRole[];
};

export const AD_CAMPAIGNS_PAGINATION_DEFAULT_FILTERS: DefaultAdCampaignFiltersType = {
  companyIds: [],
  query: '',
  statuses: DEFAULT_AD_CAMPAIGN_STATUSES,
  companyTagIds: [],
  type: [],
  replicationRoles: [ReplicationRole.None, ReplicationRole.Slave],
};

export type UseAdCampaignsPaginationPresenterProps = {
  getAdCampaigns: (args: GetAdCampaignsType) => Promise<void>;
  getMoreAdCampaigns: (args: GetAdCampaignsType) => Promise<void>;
  readAdCampaigns: ({ filters, pagination, sort }: GetAdCampaignsType) => AdCampaignsQueryPaginationType;
  mediaType?: Array<AdCampaignMediaTypeEnum>;
};

export type UseAdCampaignsPaginationPresenter<T = AdCampaignPureType> = {
  adCampaigns: T[];
  paginationInfo: PaginationInfoType;
  allAdCampaignsCount: number | null;
  filtersRef: React.MutableRefObject<AdCampaignQueryFilter>;
  requestAdCampaigns: (filters?: AdCampaignQueryFilter, pagination?: AdCampaignQueryPagination) => Promise<void>;
  loadMoreAdCampaigns: () => Promise<void>;
  onFilterExecute: (newFilters: AdCampaignQueryFilter) => Promise<void>;
  resetFilters: () => void;
};
